import {
  FetchDashboardDataRequest,
  FetchDashboardsRequest,
  SetDefaultData,
} from './map-analytics.actions'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import {
  getDashboardDataState,
  getDashboardsState,
} from './map-analytics.selectors'
import { FetchActiveLayersRequest } from '@shared/shared.actions'
import { getActiveLayers } from '@shared/shared.select'
import { getDataCyclesState } from '@containers/data-cycles/data-cycles.selectors'
import { FetchDataCyclesRequest } from '@containers/data-cycles/data-cycles.actions'

@Component({
  selector: 'app-map-analytics',
  templateUrl: './map-analytics.component.html',
  styleUrls: ['./map-analytics.component.css'],
})
export class MapAnalyticsComponent implements OnInit, OnDestroy {
  public dashboards: any[] = []
  private dashboardsState$: Subscription
  public dashboard: any
  public paramOptions = {
    LAYER: [],
    DATA_CYCLE: [],
  }
  public params = {}
  private activeLayersState$: Subscription
  private dataCyclesState$: Subscription
  public selectedLayer: any
  private _selectedLayer: any
  public data = {}
  private dashboardDataState$: Subscription
  public dashboardsTranslateKeys = []
  public dashboardsTranslateDefaults = []
  public isLoading = false

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.dashboardsState$ = this.store
      .pipe(select(getDashboardsState))
      .subscribe((state) => {
        this.dashboards = state.get('data').toJS()

        this.dashboardsTranslateKeys = this.dashboards.map(
          ({ trnKey }) => trnKey,
        )

        this.dashboardsTranslateDefaults = this.dashboards.reduce(
          (prev, { trnKey, title }) => ({
            ...prev,
            [trnKey]: title,
          }),
          {},
        )
      })

    this.activeLayersState$ = this.store
      .pipe(select(getActiveLayers))
      .subscribe((state) => {
        this.paramOptions['LAYER'] = state.toJS()
      })

    this.dashboardDataState$ = this.store
      .pipe(select(getDashboardDataState))
      .subscribe((state) => {
        const data = state.get('data').toJS()
        this.isLoading = state.get('isLoading')
        if (data && Object.keys(data).length && !this.isLoading) {
          this.data = data
          this.selectedLayer = this._selectedLayer
        }
      })

    this.dataCyclesState$ = this.store
      .pipe(select(getDataCyclesState))
      .subscribe((state) => {
        this.paramOptions['DATA_CYCLE'] = state.get('data').toJS()
      })

    this.store.dispatch<any>(new FetchDashboardsRequest())
    this.store.dispatch<any>(new FetchActiveLayersRequest())
    this.store.dispatch<any>(
      new FetchDataCyclesRequest({
        pageSize: 500,
      }),
    )
  }

  ngOnDestroy() {
    this.dashboardsState$.unsubscribe()
    this.activeLayersState$.unsubscribe()
    this.dataCyclesState$.unsubscribe()
    this.dashboardDataState$.unsubscribe()
  }

  onDashboardChange(dashboard: string) {
    this.dashboard = dashboard
    this.params = {}
  }

  onDashboardClear() {
    this.store.dispatch<any>(new SetDefaultData('dashboards'))
    this.params = {}
  }

  get dashboardParams() {
    if (this.dashboard) {
      return this.dashboard.params
    }

    return []
  }

  get paramOptionsLength() {
    return Object.keys(this.params).length
  }

  onParamChange(key: string, value: any) {
    if (key === 'layer') {
      this._selectedLayer = value
    }
    this.params[key] = value?.id
  }

  onSubmit() {
    this.store.dispatch<any>(
      new FetchDashboardDataRequest(this.dashboard.key, this.params),
    )
  }
}
